import { PropsWithChildren } from 'react';

import { useDispositiveProvisionsSuggestedRecipientsQuery } from '@/modules/aiSuggestions/AISuggestionsMatcher/graphql/SuggestedRecipients.generated';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';

import { useRecipientOptionsParams } from '../DispositiveProvisionsForm/hooks/useRecipientOptions';
import { useDispositiveProvisionsTemplateSplitScreenModalContext } from '../DispositiveProvisionsTemplateSplitScreenModal/DispositiveProvisionsTemplateSplitScreenModal.context';
import { RecipientDataContext } from './RecipientData.context';

export function RecipientDataProvider({ children }: PropsWithChildren) {
  const { householdId } = useHouseholdDetailsContext();
  const { deadPrimaryClientIds } = useRecipientOptionsParams();
  const { isTemplateMode } =
    useDispositiveProvisionsTemplateSplitScreenModalContext();
  const { data } = useDispositiveProvisionsSuggestedRecipientsQuery({
    variables: {
      householdID: householdId ?? '',
      hasDeadGrantors: deadPrimaryClientIds.length > 0 || isTemplateMode,
    },
    skip: !householdId,
    fetchPolicy: 'cache-and-network',
  });

  return (
    <RecipientDataContext.Provider value={{ data }}>
      {children}
    </RecipientDataContext.Provider>
  );
}
